import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getPresentationAttributes: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation-attribute/{presentationId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getPresentationAttributes = (presentationId) => {
  return resource.getPresentationAttributes({ presentationId })
}

export default {
  initResource,
  getPresentationAttributes,
}
